module.exports = __webpack_public_path__ + "static/img/2.924ea03.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/sp/2.png
// module id = BrVQ
// module chunks = 0